import React from 'react';
import {
    actorDetails, historyChanges, historyContext, historyFieldLabel, historyKindLabel, historySourceLabel, historyTimeLabel,
    historyValue,
} from '../../lib/historyDisplay';

/**
 * One entry of an event-contact's history (#891, #889): what changed, who and in which role, when and from
 * where, with the old to new value of each change. The board's contact drawer and Contact Detail's event
 * cards both render it, so the two never read differently.
 *
 * `item` is a `GET /api/events/{id}/history` entry (any shape `lib/historyDisplay` reads). `zone` is the
 * IANA zone the time is shown in (the browser's when absent). `compact` is the one-line-header form for
 * a card; the default is the drawer's form. The parent supplies the `key`.
 */
export default function HistoryEntry({ item, zone, compact = false }) {
    if (!item) return null;
    const changes = historyChanges(item);
    const context = historyContext(item);
    const source = historySourceLabel(item) || 'manual';
    if (compact) {
        return (
            <div className="border-l-2 border-stone-200 pl-2 text-[11px]" data-testid="history-entry">
                <p className="text-stone-500">
                    <span className="font-medium text-stone-800">{historyKindLabel(item)}</span>
                    {' · '}{actorDetails(item)}{' · '}{historyTimeLabel(item, zone)}{' · '}Source: {source}
                </p>
                {context && <p className="font-medium text-stone-600">{context}</p>}
                {changes.map((change, index) => (
                    <p className="text-stone-600" key={index}>
                        <span className="font-medium">{historyFieldLabel(change.field)}:</span> {historyValue(change.old_value)} → {historyValue(change.new_value)}
                    </p>
                ))}
            </div>
        );
    }
    return (
        <div className="border-l-2 border-stone-200 pl-3 text-xs" data-testid="history-entry">
            <p className="font-medium text-stone-800">{historyKindLabel(item)}</p>
            <p className="mt-1 text-stone-500">{actorDetails(item)} · {historyTimeLabel(item, zone)}</p>
            <p className="text-stone-500">Source: {source}</p>
            {context && <p className="mt-1 font-medium text-stone-600">{context}</p>}
            {changes.length > 0 && (
                <div className="mt-1 space-y-1 text-stone-600">
                    {changes.map((change, index) => (
                        <div key={index}><span className="font-medium">{historyFieldLabel(change.field)}:</span> {historyValue(change.old_value)} → {historyValue(change.new_value)}</div>
                    ))}
                </div>
            )}
        </div>
    );
}
